export default __webpack_public_path__ + "static/media/hd-logo-dark.e6492f84.svg";